import { StatusLabelColor } from '../../common/constants/colors';

export enum DeviationType {
  InTime = 'IN_TIME',
  Delay = 'DELAY',
  Early = 'EARLY',
}

export enum AllocationDurationType {
  InTime = 'IN_TIME',
  Faster = 'FASTER',
  Slower = 'SLOWER',
}

export enum ShipmentDeviationType {
  Early = 'EARLY',
  InTime = 'IN_TIME',
  AtRisk = 'AT_RISK',
  Delay = 'DELAY',
}

export enum ShipmentFilterType {
  InTime = 'IN_TIME',
  Delay = 'DELAY',
  Early = 'EARLY',
  Alerts = 'ALERTS',
}

export enum ShipmentQuickFilters {
  InTime = 'IN_TIME',
  Delay = 'DELAY',
  Early = 'EARLY',
  Alert = 'ALERT',
  Message = 'MESSAGE',
  AtRisk = 'AT_RISK',
  Delivered = 'DELIVERED',
  Arrived = 'ARRIVED',
  Departed = 'DEPARTED',
  InTransit = 'IN_TRANSIT',
  Planned = 'PLANNED',
  Ok = 'OK',
  Breached = 'BREACHED',
  AttentionNeeded = 'ATTENTION_NEEDED',
  Critical = 'CRITICAL',
}

export enum QuickFiltersGroupName {
  Deviation = 'deviation',
  Info = 'info',
  Milestone = 'milestone',
}

export const DEVIATION_STATUS_COLOR: Map<ShipmentDeviationType, StatusLabelColor> = new Map([
  [ShipmentDeviationType.Delay, StatusLabelColor.Red],
  [ShipmentDeviationType.InTime, StatusLabelColor.Green],
  [ShipmentDeviationType.Early, StatusLabelColor.Blue],
  [ShipmentDeviationType.AtRisk, StatusLabelColor.Yellow],
]);

export const SHIPMENT_FILTER_COLOR: Map<ShipmentFilterType, StatusLabelColor> = new Map([
  [ShipmentFilterType.InTime, StatusLabelColor.Green],
  [ShipmentFilterType.Early, StatusLabelColor.Yellow],
  [ShipmentFilterType.Delay, StatusLabelColor.Red],
  [ShipmentFilterType.Alerts, StatusLabelColor.Blue],
]);

export const SHIPMENT_QUICK_FILTER_COLOR: Map<ShipmentQuickFilters, StatusLabelColor> = new Map([
  [ShipmentQuickFilters.InTime, StatusLabelColor.Green],
  [ShipmentQuickFilters.Early, StatusLabelColor.Blue],
  [ShipmentQuickFilters.Delay, StatusLabelColor.Red],
  [ShipmentQuickFilters.Alert, StatusLabelColor.Gray],
  [ShipmentQuickFilters.Message, StatusLabelColor.Gray],
  [ShipmentQuickFilters.Critical, StatusLabelColor.Gray],
  [ShipmentQuickFilters.AtRisk, StatusLabelColor.Yellow],
  [ShipmentQuickFilters.Delivered, StatusLabelColor.Gray],
  [ShipmentQuickFilters.Arrived, StatusLabelColor.Gray],
  [ShipmentQuickFilters.Departed, StatusLabelColor.Gray],
  [ShipmentQuickFilters.InTransit, StatusLabelColor.Gray],
  [ShipmentQuickFilters.Planned, StatusLabelColor.Gray],
  [ShipmentQuickFilters.Ok, StatusLabelColor.Green],
  [ShipmentQuickFilters.Breached, StatusLabelColor.Red],
  [ShipmentQuickFilters.AttentionNeeded, StatusLabelColor.Gray],
]);

export const SHIPMENT_QUICK_FILTER_CONTROL: Map<ShipmentQuickFilters, QuickFiltersGroupName> = new Map([
  [ShipmentQuickFilters.InTime, QuickFiltersGroupName.Deviation],
  [ShipmentQuickFilters.Early, QuickFiltersGroupName.Deviation],
  [ShipmentQuickFilters.Delay, QuickFiltersGroupName.Deviation],
  [ShipmentQuickFilters.Alert, QuickFiltersGroupName.Info],
  [ShipmentQuickFilters.Message, QuickFiltersGroupName.Info],
  [ShipmentQuickFilters.AtRisk, QuickFiltersGroupName.Deviation],
  [ShipmentQuickFilters.Delivered, QuickFiltersGroupName.Milestone],
  [ShipmentQuickFilters.Arrived, QuickFiltersGroupName.Milestone],
  [ShipmentQuickFilters.Departed, QuickFiltersGroupName.Milestone],
  [ShipmentQuickFilters.InTransit, QuickFiltersGroupName.Milestone],
  [ShipmentQuickFilters.Planned, QuickFiltersGroupName.Milestone],
]);

export interface Deviation {
  deviationType: ShipmentFilterType;
  arrivalDeviation: number;
  departureDeviation?: number;
}

export interface DeliveryDeviation {
  type: ShipmentFilterType;
  valueInHours: number;
}

export class DeliveryDeviationModel implements Deviation {
  deviationType: ShipmentFilterType;
  arrivalDeviation: number;

  constructor(params?: DeliveryDeviation) {
    if (params) {
      const { type, valueInHours } = params;

      this.deviationType = type;
      this.arrivalDeviation = valueInHours;
    }
  }
}
